import type { ReactNode, MouseEventHandler } from 'react';

export interface TableRowProps {
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLTableRowElement>;
  header?: boolean;
  className?: string;
}

export const TableRow = ({ children, onClick, header = false, className = '', ...rest }: TableRowProps) => (
  <tr
    onClick={onClick}
    className={`${header ? 'bg-[#edf4f5] border-b border-gray-200' : 'border-b border-gray-100'} ${onClick ? 'cursor-pointer hover:bg-gray-50 transition-colors' : ''} ${className}`}
    {...rest}
  >
    {children}
  </tr>
);
